import React, { useState } from "react";
import {
  CheckBoxWrapper,
  CheckBoxLabel,
  CheckBox,
  SwitchOptions,
} from "./index.styled";

export default function ToggleOption({ option1, option2 }) {
  const [toggleState, setToggleState] = useState(false);

  return (
    <CheckBoxWrapper>
      <CheckBox
        id="checkbox"
        type="checkbox"
        onClick={(e) => setToggleState(e.target.checked)}
      />
      <CheckBoxLabel htmlFor="checkbox">
        <SwitchOptions className={toggleState && "active"}>
          <img
            src={
              !toggleState
                ? "/images/svg/document-upload.svg"
                : "/images/svg/document-upload-gray.svg"
            }
            style={{ marginLeft: "7px" }}
            alt="icon"
          />{" "}
          {option2}
        </SwitchOptions>
        <SwitchOptions className={!toggleState && "active"}>
          <img
            src={
              toggleState
                ? "images/svg/text-icon.svg"
                : "images/svg/text-icon-gray.svg"
            }
            style={{ marginLeft: "7px" }}
            alt="icon"
          />{" "}
          {option1}
        </SwitchOptions>
      </CheckBoxLabel>
    </CheckBoxWrapper>
  );
}
